import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';
import { colors, fonts, spacing, borderRadius, shadows } from '../../constants';

/**
 * SLAPriorityChart Component
 * Bar chart component for SLA by priority
 */
const SLAPriorityChart = ({ data }) => {
  return (
    <Box sx={{ flex: '1 1 50%', width: { xs: '100%', md: '50%' }, minWidth: 0 }}>
      <Paper sx={{ p: spacing.xs, borderRadius: borderRadius.md, boxShadow: shadows.md, width: '100%', height: '100%' }}>
        <Typography variant="h6" sx={{ fontWeight: fonts.weightBold, mb: spacing.xs, fontSize: fonts.fontSizeSm }}>
          SLA Performance by Priority
        </Typography>
        <ResponsiveContainer width="100%" height={180}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke={colors.borderDefault} />
            <XAxis dataKey="priority" stroke={colors.textSecondary} tick={{ fontSize: 11 }} />
            <YAxis stroke={colors.textSecondary} tick={{ fontSize: 11 }} />
            <RechartsTooltip />
            <Legend wrapperStyle={{ fontSize: '11px' }} />
            <Bar dataKey="adherence" fill={colors.success} name="Adherence %" />
            <Bar dataKey="breached" fill={colors.error} name="Breached" />
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Box>
  );
};

export default SLAPriorityChart;
